import { Controllers } from 'lib/enums/routes/_controllers';
import { DealersRoutes } from 'lib/enums/routes/dealers';
import { DealerDoc } from 'lib/interfaces/database/dealer';
import { UserWhole } from 'lib/interfaces/database/user';
import { BaseService } from 'services/_base';

export class DealersService extends BaseService {
  private static instance: DealersService;

  static getInstance(): DealersService {
    if (!DealersService.instance) {
      DealersService.instance = new DealersService();
    }

    return DealersService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.dealers,
    });
  }

  getAll() {
    return this.GET({
      uri: DealersRoutes.GetAll,
    })
      .then((result: UserWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(userID: string, payload: Partial<DealerDoc>) {
    return this.POST(
      {
        uri: `${DealersRoutes.CreateOne}/${userID}`,
      },
      payload
    )
      .then((result: UserWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  update(id: string, payload: Partial<DealerDoc>) {
    return this.PUT(
      {
        uri: `${DealersRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: UserWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
